import moment from 'moment/moment';
import { ReactComponent as Edit2 } from '../../assets/svgs/edit.svg';
import { ReactComponent as ViewIcon } from '../../assets/svgs/eye.svg';
import HeaderCell from '../../components/table/HeaderCell';

const getStatusColor = (status) => {
  switch (status) {
    case "Approved":
      return "#E4FAEE";
    case "Pending":
      return "#FFD6D6";
    default:
      return "gray.100";
  }
};

const getStatusTextColor = (status) => {
  switch (status) {
    case "Approved":
      return "#157E36";
    case "Pending":
      return "#FF0000";
    default:
      return "gray.100";
  }
};

const columns = ({
    onEditOpen,
    onViewOpen,
    statusFilter,
    onSelectRow = () => {},
  }) => [
    {
      id: 1,
      cell: (row) =>
        statusFilter === "Pending Approval" ? (
          <input
            type="checkbox"
            onChange={(e) => onSelectRow(e.target.checked, row)}
          />
        ) : null,
      ignoreRowClick: true,
      button: true,
    },
    {
      id: 2,
      name: <HeaderCell label={"REQUEST ID"} />,
      selector: (row) => row?.id, // Using `id` as SKU
      minWidth: "100px",
    },
    {
      id: 3,
      name: <HeaderCell label={"SELLER NAME"} />,
      minWidth: "250px",
      selector: (row) => `${row.first_name} ${row.surname}`,
    },    
    {
      id: 4,
      name: <HeaderCell label={"REQUEST MADE"} />,
      minWidth: "100px",
      selector: (row) => moment(row.date_created).format("DD/M/YYYY"),
    },
    // {
    //   id: 4,
    //   name: <HeaderCell label={"LOCATION"} />,
    //   selector: (row) => row.address,
    // },
    {
      id: 5,
      name: <HeaderCell label={"APPROVAL STATUS"} />,
      selector: (row) =>row?.authUser ? ( row.authUser?.verify ? "Approved" : "Pending") : " - ",
      cell: (row) => {
        const status = row?.authUser ? row.authUser?.verify === true ? "Approved" : "Pending" : "-"
    
        return (
          <span
            style={{
              backgroundColor: getStatusColor(status),
              color: getStatusTextColor(status),
              padding: "4px 10px",
              borderRadius: "999px",
              fontSize: "14px",
              fontWeight: "500",
              width: "fit-content",
              height: "28px",
              fontFamily: "PlusJakartaSansRegular",
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <span
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: getStatusTextColor(status),
              }}
            ></span>
            {status}
          </span>
        );
      },
    },    
    {
      id: 6,
      name: <HeaderCell label={"ACTION"} />,
      cell: (row) =>
        <Edit2
            width={20}
            height={20}
            cursor={"pointer"}
            onClick={() => onEditOpen(row)}
          />
    },
  ];
  

  const data = [
    {
      bag_id: "123",
      id: 1,
      product_name: 'Peter',
      brand_name: '12/06/2025',
      location: "London",
      status: "Pending",
      website_link: 'https://www.google.com'
    },
    {
      bag_id: "123",
      id: 2,
      product_name: 'Alan',
      brand_name: '13/06/2025',
      location: "Manchester",
      status: "Approved",
      website_link: 'https://www.google.com'
    },
    {
      bag_id: "123",
      id: 3,
      product_name: 'James',
      brand_name: '14/06/2025',
      location: "Birmingham",
      status: "Approved",
      website_link: 'https://www.google.com'
    },
    {
      bag_id: "123",
      id: 4,
      product_name: 'David',
      brand_name: '15/06/2025',
      location: "Liverpool",
      status: "Pending",
      website_link: 'https://www.google.com'
    },
    {
      bag_id: "123",
      id: 5,
      product_name: 'Michael',
      brand_name: '16/06/2025',
      location: "Leeds",
      status: "Pending",
      website_link: 'https://www.google.com'
    },
    {
      bag_id: "123",
      id: 6,
      product_name: 'Robert',
      brand_name: '17/06/2025',
      location: "Sheffield",
      status: "Approved",
      website_link: 'https://www.google.com'
    },
    {
      bag_id: "123",
      id: 7,
      product_name: 'William',
      brand_name: '18/06/2025',
      location: "Bristol",
      status: "Approved",
      website_link: 'https://www.google.com'
    },
    {
      bag_id: "123",
      id: 8,
      product_name: 'Richard',
      brand_name: '19/06/2025',
      location: "Newcastle",
      status: "Pending",
      website_link: 'https://www.google.com'
    },
    {
      bag_id: "123",
      id: 9,
      product_name: 'Thomas',
      brand_name: '20/06/2025',
      location: "Nottingham",
      status: "Pending",
      website_link: 'https://www.google.com'
    },
    {
      bag_id: "123",
      id: 10,
      product_name: 'Daniel',
      brand_name: '21/06/2025',
      location: "Leicester",
      status: "Approved",
      website_link: 'https://www.google.com'
    },
    {
      bag_id: "123",
      id: 11,
      product_name: 'Christopher',
      brand_name: '22/06/2025',
      location: "Cambridge",
      status: "Pending",
      website_link: 'https://www.google.com'
    },
    {
      bag_id: "123",
      id: 12,
      product_name: 'Andrew',
      brand_name: '23/06/2025',
      location: "Oxford",
      status: "Pending",
      website_link: 'https://www.google.com'
    },
  ];

export { data, columns };